import styled, { css } from 'styled-components'

export const AlignWrappers = styled.div`
  flex: 1;
  max-width: 1040px;
  margin-bottom: 24px;

  ${({ noMargin }) => noMargin && css`
    margin-bottom: 0;
  `}

  ${({ isHome }) => isHome && css`
      margin-top: 28px;
  `}
`

export const WrapperForm = styled(AlignWrappers)`
  display: flex;
  flex-direction: column;

  ${({ noMargin }) => noMargin && css`
    margin-bottom: 0;
  `}
`

export const WrapperTitle = styled.div`
  color: var(--gray-2);
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 27px;

  ${({ firstContainer }) => firstContainer && css`
    @media screen and (max-width: 1200px) {
      margin-top: 28px;
    }
  `}

  ${({ isHome }) => isHome && css`
      margin-top: 24px;

      @media screen and (max-width: 575px) {
        margin-top: 0;
      }
  `}

  ${({ isServices }) => isServices && css`
    font-size: 16px;
    line-height: 19.2px;
  `}

  ${({ isPet }) => isPet && css`
    margin-bottom: 16px;
  `}
`

export const WrapperCards = styled.div`
  margin-top: 16px;
  max-width: calc(100vw - 32px - 234px);
  @media (max-width: 575px) {
    max-width: calc(100vw - 32px);
  }

  .slick-track {
    display: flex;
    gap: 16px;
  }

  .slick-slide {
    margin: 0;
    &:last-child {
      > div {
        &:last-of-type {
          justify-content: center;
          > div {
            height: fit-content;
          }
        }
      }
    }
    > div {
      height: 100%;
      &:last-of-type {
        display: flex;
        flex-direction: column;
        > div {
          height: 100%;
        }
      }
    }
  }

  .slick-dots {
    margin: 16px 0;
    position: unset;

    li {
      justify-content: center;
      margin: 0;
      list-style: none;

      button {
        font-size: 0;
        border: none;
        ::before {
          color: transparent;
        }
        background-color: var(--silver);
        width: 8px;
        height: 8px;
        border-radius: 50px;
      }
    }

    .slick-active {
      button {
        background-color: var(--cobasi-blue-light-8);
        width: 12px;
        height: 12px;
      }
    }
  }

  .slick-list {
    padding: 0 !important;
    display: grid;
    @media (max-width: 575px) {
      overflow: initial;
    }
  }
`

export const Link = styled.a`
  color: var(--cobasi-blue-light-9);
  text-align: center;

  font-family: 'Montserrat';
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  text-decoration-line: underline;
  cursor: pointer;
`

export const ScheduleCard = styled.div`
  display: flex;
  min-width: 296px;
  height: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 16px;
  border: 1px solid var(--silver);
  align-self: stretch;

  > div:nth-last-child(1) {
    margin-bottom: 0;
  }

  button {
    padding: 8px;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--the-white);
    text-align: center;

    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    line-height: 150%;

    span {
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: 8px;
    }
  }
`

export const SchedulingPet = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  width: 100%;
  border-bottom: 1px solid var(--silver);
  margin-bottom: 16px;

  div {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`

export const PetName = styled.span`
    overflow: hidden;
    color: var(--gray-2);
    text-overflow: ellipsis;
    font-family: 'Montserrat';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
}`

export const SchedulingInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  background-color: var(--neutral-gray);
  margin-bottom: 11px;
  border-radius: 8px;

  span {
    color: var(--gray-5);

    font-family: 'Montserrat';
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`

export const Icon = styled.div`
  ${({ size, src, setDefaultPhoto, location }) => css`
    width: ${size || '16px'};
    height: ${size || '16px'};
    margin-left: ${location ? '-1px' : '0'};
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-image: url("${src}");
    background-size: ${setDefaultPhoto ? 'contain' : 'cover'};
    background-repeat: no-repeat;
    background-position: center center;
  `}
`

export const Photo = styled.div`
  ${({ size, src, setDefaultPhoto, mobileSize }) => css`
    width: ${size || '40px'};
    height: ${size || '40px'};
    border-radius: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-image: url("${src}");
    background-size: ${setDefaultPhoto ? 'contain' : 'cover'};
    background-repeat: no-repeat;
    background-position: center center;

    @media screen and (max-width: 1200px) {
      width: ${mobileSize || '40px'};
      height: ${mobileSize || '40px'};
    }

  `}
`
